module.exports = __webpack_public_path__ + "e0f4483533c48a7c0ede0109b5fbda5d.svg";